// ── Fade-In Scroll Animation ──
(function () {
  const elements = document.querySelectorAll('.fade-in-section');
  if (!elements.length) return;

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target); // trigger once only
        }
      });
    },
    {
      threshold: 0.12,   // triggers when 12% of element is visible
      rootMargin: '0px 0px -40px 0px'  // fires slightly before full entry
    }
  );

  elements.forEach(function (el) {
    observer.observe(el);
  });
})();